import InputMask from 'react-input-mask';
import styled from 'styled-components';

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export default Wrapper;

export const MaskedInput = styled(InputMask)`
  width: 100%;
  height: 35px;
  padding: 0 8px;
  border: 1px #57595d solid;
  background-color: #2E3136;
  color: #838488;
  text-align: center;

  &:focus {
    border-color: #FFC709;
  }

  /* #35383D */
`;
